export default "__VITE_ASSET__CSyHbyke__"